import { render } from "./ContentEditor.vue?vue&type=template&id=6b1efac4"
import script from "./ContentEditor.vue?vue&type=script&lang=js"
export * from "./ContentEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__